function initSlider()
{
	// params
	const cycle_resume_time = 4000; // ms
	const cycle_time = 6000;
	const cycle_speed = 1000;
	const auto_slide = true;
	//
	const slider = $('div.home-slider');
    const items = slider.find('div.items');

    // fade in
    slider.animate({opacity: 1}, 100, 'linear');

	// cycle
	var cycle_pager = $('div.home-slide div.buttons');
	if(items.find('> *').length > 1) {
		//$('div.HomeSlide').append('<div class="buttons"></div>');
		items.cycle( {
			 slides: "> .item"
			,timeout: cycle_time
			,speed: cycle_speed
			,paused: !auto_slide
			,pauseOnHover: true
			,random: false
			,fx: 'fade'
			,pager: 'div.home-slider div.buttons'
			,sync: true
			,pagerActiveClass: 'active'
			,pagerTemplate: '<a href="javascript:">&bull;</a>'
			,autoHeight: 'calc'
			,swipe: true
			,swipeFx: 'scrollHorz'
		});
	}
	if(auto_slide) {
		let cycle_resume_timeout;
		cycle_pager.on('click', function() {
			items.cycle('pause');
			clearTimeout(cycle_resume_timeout);
			cycle_resume_timeout = setTimeout( function() {
				items.cycle('resume');
			}, cycle_resume_time);
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
    initSlider()
})
